import axios from 'axios';
import config from '../config';

function login(email: string, pass: string) {
  return axios({
    method: 'POST',
    baseURL: config.host,
    url: '/auth/local',
    timeout: config.timeout,
    data: {
      identifier: email,
      password: pass,
    },
  });
}

export default {
  login
};
